<template>
    <div class="modal-content modal--happy">
        <div class="modal-header border-0 text-ceter">
            <modal-close />
            <div class="modal-title">
                <h2 class="h3 px-2 pt-4 pb-1">
                    {{ this.$brand.cookies.cookiesModalTitle }}
                </h2>
            </div>
        </div>
        <div class="modal-body p-4 text-primary">
            <div class="tr-data mb-4 is-column">
                <privacy-policy />
            </div>

            <div class="text-center">
                <button
                    class="btn btn-outline-secondary"
                    @click="closeModal"
                    data-dismiss="modal"
                >
                    Zamknij
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import PrivacyPolicy from '@/components/privacy-policy/PrivacyPolicy.vue'

export default {
    components: { PrivacyPolicy },
    methods: {
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        }
    }
}
</script>
